import { render, staticRenderFns } from "./FraudConfig.vue?vue&type=template&id=256b4760&scoped=true&"
import script from "./FraudConfig.vue?vue&type=script&lang=js&"
export * from "./FraudConfig.vue?vue&type=script&lang=js&"
import style0 from "./FraudConfig.vue?vue&type=style&index=0&id=256b4760&scoped=true&lang=css&"
import style1 from "./FraudConfig.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256b4760",
  null
  
)

export default component.exports